window.onload = check_onload;
var item = null;
var NOTFOUND='not found';
var session='';
var url_base = 'https://apps.unikx.net/apps';

function check_onload(){
    document.body.className += " loaded";
	check_ios();
	create_session();
	ipsource = "";
	send_ipsource(ipsource, false, true);
}

function check_ios(){
	if(navigator.userAgent.indexOf('Safari')!=-1&&navigator.userAgent.indexOf('Chrome')==-1&& document.cookie!="") window.open(url_base+'/home?close', '_blank');
	
}

function create_session(){
	session = generateHexString(58);
	console.log(session);
}

function generateHexString(length) {
  var ret = "";
  while (ret.length < length) {
    ret += Math.random().toString(16).substring(2);
  }
  return ret.substring(0,length);
}

function build_request(_ipsource, _item, _openclose){
	
	var userLang = $('html').attr('lang');
	var parent_language = userLang;
	var parent_url = window.location.href;
	var parent_prokey = '';
	var parent_product_ref='';
    var parent_item_measurement_system='';

    if (_item==null){
    	console.log('item null');
    	if ($(document).find("[data-ztprokey]").length>0){
    		parent_prokey = $($(document).find("[data-ztprokey]")[0]).data('ztprokey');
    	}
    }else{
    	console.log('item not null')
    	parent_prokey = _item.data('ztprokey');
	    parent_product_ref = _item.data('product-ref');
	    parent_item_measurement_system = _item.data('ztmeasurement-system');
    }
    
   	

   	var request=new Object();
   	request.ip = _ipsource;
   	request.session = session;
    request.parent_prokey  = parent_prokey;
	request.parent_item_product_ref = parent_product_ref;
	request.parent_item_measurement_system = parent_item_measurement_system;
	request.parent_language = parent_language;
	request.parent_url = parent_url;
	request.openclose = _openclose;
	return request;
}

function send_ipsource(_ipsource, _all, _openclose){
	
	var request = new Object();

	if (_all){
		request = build_request(_ipsource, item, _openclose);
	}else{
		request = build_request(_ipsource, null,_openclose);
	}
	console.log('ip sent');
	$.ajax({
	    url: url_base+'/ipclient',
	    data: request,
	    crossOrigin: true,
	    dataType: 'json',
	    success: function (data) {
		    console.log('ip recevied');
	    }
	});
}

$(window).resize(function(){
	var viewportwidth = window.innerWidth
					|| document.documentElement.clientWidth
					|| document.body.clientWidth;

	var viewportheight = window.innerHeight
					|| document.documentElement.clientHeight
					|| document.body.clientHeight;


	if( navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i) ) {
		
	    $('#zt_modal').css({
	    	position: 'fixed',
	        bottom: '0px',
            top:'0px',
            right:'0px',
            left:'0px'
	    });
	    if(navigator.userAgent.match(/iPhone|iPad|iPod/i)){
        	$(this).css({
        		overflow:'auto'
        	});
        }
        if(navigator.userAgent.match(/iPad/i)){
        	$(this).css({
        		top:'60px'
        	});
        }

	}else{
		$('#zt_modal').css({
        	'-webkit-overflow-scrolling': 'touch',
            width:viewportwidth+'px',
	        height:viewportheight+'px',
	        top:'60px'
        });
	}
});

(function($) {
	jQuery(document).ready(function(){
		jQuery("#nav-pills.li.a").on("click", function(){
			jQuery("#nav-pills.li.a").each(function(){
				jQuery(this).removeClass("active");
			});
			jQuery(this).addClass("active");
		});
		jQuery(".zt_btn").on("click", function(e){
			item = jQuery(this);
			getZTattr(jQuery(this));
			
			console.log(item);
		});

		var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
		var eventer = window[eventMethod];
		var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";

		// Listen to message from child window
		eventer(messageEvent,function(e) {
		    var key = e.message ? "message" : "data";
		    var data = e[key];
		    if (data=="close"){
		    	closeZTFrame();
		    }
		},false);
		
	}); 



	function closeZTFrame(){
		$('#zt_modal').modal('toggle');
		$('#zt_modal').remove();
		
		send_ipsource("", true, false);
		item = null;
	}

	//generates the iframe
  	function getZTattr(_item){
  		$('#zt_modal').remove();

		send_ipsource("", true, true);

  		var userLang = $('html').attr('lang');
	    var parent_url = window.location.href;
	    var item_id = "#"+_item.data('itemid'); //itemid is the id of the item container div
	    var parent_prokey = _item.data('ztprokey');
	    var parent_product_ref = _item.data('product-ref');
	    var parent_item_price = $($(item_id).find("#"+_item.data('item-price'))[0]).text().replace(/\s+/g, '');
	    var parent_item_name = $($(item_id).find("#"+_item.data('item-title'))[0]).text();
	    var parent_item_measurement_system = _item.data('ztmeasurement-system');
	    var parent_item_sizes = _item.data('ztsizes');
	    var parent_item_desc1 = _item.data('ztdesc1');
	    var parent_item_desc2 = _item.data('ztdesc2');
	    var parent_item_desc3 = _item.data('ztdesc3');
	    //var parent_item_picture_url = $($(item_id).find("#"+_item.data('img'))[0]).prop('src'); //use prop to get absolute path
        var parent_item_picture_url = _item.data('img');
        //console.log(parent_item_picture_url);
		var parent_language = userLang;
	    var params="?parent_url="+encodeURIComponent(parent_url)+"&"+
	                  "pro_key="+ encodeURIComponent(parent_prokey) +"&"+
	                  "parent_item_product_ref="+ encodeURIComponent(parent_product_ref) +"&"+
	                  "parent_item_price="+encodeURIComponent(parent_item_price)+"&"+
	                  "parent_item_name="+encodeURIComponent(parent_item_name)+"&"+
	                  "parent_item_picture_url="+encodeURIComponent(parent_item_picture_url)+"&"+
	                  "parent_item_measurement_system="+encodeURIComponent(parent_item_measurement_system)+"&"+
	                  "parent_item_sizes="+encodeURIComponent(parent_item_sizes)+"&"+
	                  "parent_item_desc1="+encodeURIComponent(parent_item_desc1)+"&"+
	                  "parent_item_desc2="+encodeURIComponent(parent_item_desc2)+"&"+
	                  "parent_item_desc3="+encodeURIComponent(parent_item_desc3)+"&"+
	                  "parent_language="+encodeURIComponent(parent_language);

	    var source =  url_base+"/entrypoint"+params;
	    htmlstr = 	"<div class=\"modal  zt_modal_display\" id=\"zt_modal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden\"true\">"+
	    				
						 //"<div type=\"button\" class=\"close close-icon\" data-dismiss=\"modal\" aria-label=\"Close\"></div>"+
	    				
	    				"<div id=\"zt_modal_dialog\" class=\"modal-dialog\" >"+
	    					
						   
	    					"<div id=\"zt_modal_content\" class=\"modal-content\" >"+	
	    						 //"<div id=\"zatfitsmodal-header\" class=\"modal-header\" style=\"margin-left:20px!important;margin-right:20px!important;\">"+
							     //   "<button type=\"button\" class=\"close sectiontitle\" data-dismiss=\"modal\" aria-hidden=\"true\"></button>"+
							     // "</div>"+
	    						//"<a class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><img src=\"assets/img/croix_fermer_bis.jpg\" /></a> "+&times;
				    			"<div class=\"modal-body \" id=\"zt-frame_container\" >"+

				    			"</div>"+
				    		"</div>"+
				    	"</div>"+
				    "</div>";
	    $(_item).after(htmlstr);
	    
        $('#zt-frame_container').html("<iframe class =\"\" id=\"zatfits-frame\" scrolling=\"no\" src=\"\" ></iframe>"); 
        
        // iOS check...ugly but necessary
		if( navigator.userAgent.match(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i) ) {
		    console.log('this is apple');
		    $('#zt_modal').on('show.bs.modal', function() {
		        $(this).find('iframe').attr('src',source);
				var viewportwidth = window.innerWidth
								|| document.documentElement.clientWidth
								|| document.body.clientWidth;

				var viewportheight = window.innerHeight
								|| document.documentElement.clientHeight
								|| document.body.clientHeight;
		        $(this)
		            .css({
		            	
		            	position: 'fixed',
		                bottom: '0px',
			            top:'0px',
			            right:'0px',
			            left:'0px'
		            });

		        if(navigator.userAgent.match(/iPhone|iPad|iPod/i)){
		        	$(this).css({
		        		overflow:'auto'
		        	});
		        }
		    	if(navigator.userAgent.match(/iPad/i)){
		        	$(this).css({
		        		top:'60px'
		        	});
		        }
		    });
		}else{
			console.log('this is not apple');
			$('#zt_modal').on('shown.bs.modal',function(){      //correct here use 'shown.bs.modal' event which comes in bootstrap3
	   		  	$(this).find('iframe').attr('src',source);
				var viewportwidth = window.innerWidth
								|| document.documentElement.clientWidth
								|| document.body.clientWidth;

				var viewportheight = window.innerHeight
								|| document.documentElement.clientHeight
								|| document.body.clientHeight;
			  	$(this)
		            .css({
		            	'-webkit-overflow-scrolling': 'touch',
		                width:viewportwidth+'px',
				        height:viewportheight+'px',
				        top:'60px'
			            //width:'500px!important',
			            //height:'620px!important'
					            });
			});
		}
      	
      	$('#zt_modal').on('hidden.bs.modal', function () {
		    $('body').css('overflow','');
		    $('body').css('-webkit-overflow-scrolling','')
			$('body').css('position','');
		});
       
		$('#zt_modal').modal('toggle');
        $('#zt_modal_dialog').attr('css','margin: auto;');
  	}

  	
})(jQuery);
